import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getCompanyDetails,
  upsertCompanyDetails,
  UpsertCompanyDetailsRequest,
} from '../api/companyDetailsApi';

export const companyDetailsKeys = {
  all: ['organisation', 'company-details'] as const,
};

export function useGetCompanyDetails() {
  return useQuery({
    queryKey: companyDetailsKeys.all,
    queryFn: getCompanyDetails,
  });
}

export function useUpsertCompanyDetails() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpsertCompanyDetailsRequest) =>
      upsertCompanyDetails(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: companyDetailsKeys.all });
    },
  });
}
